module.exports = __webpack_public_path__ + "img/TechGatherBerry1_ua.ee53eed0.webp";